import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';

import { DispositionReason } from '../../coaching-base/config';
import {
    CmpsForm,
    CmpsFormBuilder,
} from '../../coaching-observation/experimental.form';
import { TranslationKeyMap } from '../coaching-commitment.i18n';
import { CloseContext } from '../commitment/close-context.model';

import { CloseFormFields, CloseFormValue } from './close.commitment.form';

@Component({
    selector: '[cmpsCommitmentClose]',
    templateUrl: './close.commitment.component.html',
})
export class CloseCommitmentComponent implements OnInit, OnDestroy {
    /** @private */ _dispositionReasonsOpts: Array<{
        value: number;
        label: string;
    }>;

    /** @private */ _i18n = TranslationKeyMap;

    // eslint-disable-next-line accessor-pairs
    private set _dispositionReasons(value: DispositionReason[]) {
        this._dispositionReasonsOpts = (value || []).map((e) => ({
            value: e.dispositionReasonId,
            label: e.dispositionReasonName,
        }));
    }

    /** @private */ _form: CmpsForm<CloseFormFields, CloseFormValue>;

    constructor(
        private readonly _formBuilder: CmpsFormBuilder,
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            CloseCommitmentComponent,
            CloseContext
        >,
        /** @private */ @Inject(CMPS_DIALOG_DATA)
        readonly _data: DispositionReason[],
    ) {
        this._dispositionReasons = _data;
    }

    ngOnInit(): void {
        this._form = this._formBuilder.create<CloseFormFields>(CloseFormFields);
    }

    ngOnDestroy(): void {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this._form && this._form.destroy();
    }

    /** @private */ _onSubmitClick(): void {
        this._form.checkWarningsErrors();
        if (!this._form.form.valid) {
            return;
        }
        const opt = this._dispositionReasonsOpts.find(
            (e) => e.value === this._form.value.reason,
        );
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        this._dialogRef &&
            this._dialogRef.close({
                dispositionReasonId: opt.value,
                reason: opt.label,
                comment: this._form.value.comment
                    ? this._form.value.comment.contents
                    : null,
            });
    }
}
